/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";

interface FastProps {
  src: string; // "/images/Circle.svg"
  alt?: string;
  width: string;
  height?: string;
  solo?: boolean; // true if card has no header
  priority?: boolean; // true image should have loading priority
}

export const FastCardImage = ({ src, alt, width, height, solo }: FastProps) => {
  return (
    <FastCardImageWrapper solo={solo}>
      <img
        src={src}
        width={width}
        height={height}
        alt={alt}
        style={{ outline: "1px solid black", outlineOffset: "-1px" }}
      />
    </FastCardImageWrapper>
  );
};

interface WrapperProps {
  solo?: boolean;
}

const FastCardImageWrapper = styled.div<WrapperProps>`
  margin-bottom: 10px;
  margin-top: ${(props) => (props.solo ? "36px" : "16px")};
  width: 426px;

  @media (max-width: ${DEVICE.small}) {
    width: 200px;
  }
`;
